import { ApiDOMStructuredError } from '@swagger-api/apidom-error';

/**
 * @public
 */
class JsonPointerError extends ApiDOMStructuredError {}
export default JsonPointerError;